import { Edit, useForm } from "@refinedev/antd";
import { Form, Input } from "antd";
import { useParams } from "react-router-dom";

interface IWorkout {
    data:{
    id: string;
    name: string;
    description: string;
    }
}

export const WorkoutEdit = () => {
    const { id } = useParams();
    
    const { formProps, saveButtonProps, query, formLoading} = useForm<IWorkout>({
        redirect: "list",
        id,
    });

    // Get initial values from the query result
    const workoutData = query?.data?.data?.data;

    // console.log(workoutData);

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Form 
                {...formProps} 
                layout="vertical"
                initialValues={{
                    name: workoutData?.name,
                    description: workoutData?.description,
                }}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter a name',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter a description',
                        },
                    ]}
                >
                    <Input.TextArea rows={4} />
                </Form.Item>
            </Form>
        </Edit>
    );
}; 